// import React, {FC, useEffect, useRef, useState} from 'react'
// import "react-datetime/css/react-datetime.css";
// import './datepicker.scss'
// import DateTime, {ViewMode} from 'react-datetime';
// import {Input} from '../../ui-components';
// import moment, {Moment} from 'moment';
// import {CalendarIcon, ArrowDownIcon} from '../../assets';
// import 'moment/locale/ru';
//
// interface Props {
//   label?: string
//   className?: string
//   value: Moment | string | null
//   initialValue?: Moment | string | null
//   name?: string
//   error?: boolean
//   disableDates?: string
//   inputDisabled?: boolean
//   handleDateChange: Function
//   initialView?: ViewMode
//   readOnly?: boolean
// }
//
// const Datepicker: FC<Props> = (props) => {
//   const {label, value, name, error, initialValue, inputDisabled} = props
//   const inputProps = {
//     readOnly: true,
//     className: `custom-input ${props.className ? props.className : ''}`,
//   }
//
//   const yesterday = moment().subtract(1, 'day');
//   let valid = (current) => current.isAfter(yesterday);
//
//   if (props.disableDates) {
//     if(props.disableDates === 'future') {
//       const today = moment();
//       valid = (current) => current.isBefore(today);
//     }
//   }
//
//   const renderInput = (props) => <Input startIcon={<CalendarIcon/>}
//                                         name={name}
//                                         error={error}
//                                         disabled={inputDisabled}
//                                         onKeyDown={(e) => {
//                                           if(props.readOnly) {
//                                             e.preventDefault()
//                                           }
//                                         }}
//                                         endIcon={<ArrowDownIcon/>}
//                                         label={label} {...props}/>
//
//   return (
//     <DateTime dateFormat={'DD/MM/YYYY'}
//               isValidDate={props.disableDates ? valid : () => true}
//               inputProps={inputProps}
//               onNavigate={() => 'years'}
//               initialViewMode={props.initialView}
//               closeOnSelect={true}
//               timeFormat={false}
//               inputDisabled={inputDisabled}
//               value={moment(new Date(value as any)) || ''}
//               initialValue={new Date(initialValue as any) || ''}
//               onChange={(date) => {
//                 props.handleDateChange(date)
//               }}
//               open={inputDisabled ? false : undefined}
//               renderInput={renderInput}/>
//   )
// }
//
// export default Datepicker

import React, { FC } from 'react';
import "react-datetime/css/react-datetime.css";
import './datepicker.scss';
import DateTime, { ViewMode } from 'react-datetime';
import { Input } from '../../ui-components';
import moment, { Moment } from 'moment';
import { CalendarIcon, ArrowDownIcon } from '../../assets';
import 'moment/locale/ru';

interface Props {
  label?: string;
  className?: string;
  value: Moment | string | null;
  initialValue?: Moment | string | null;
  name?: string;
  error?: boolean;
  disableDates?: 'past' | 'future' | 'todayOnly'; // <-- managed prop
  inputDisabled?: boolean;
  handleDateChange: (date: Moment | string) => void;
  initialView?: ViewMode;
  readOnly?: boolean;
}

const Datepicker: FC<Props> = ({
                                 label,
                                 value,
                                 name,
                                 error,
                                 initialValue,
                                 inputDisabled,
                                 className,
                                 disableDates,
                                 handleDateChange,
                                 initialView,
                                 readOnly
                               }) => {
  const inputProps = {
    readOnly: true,
    className: `custom-input ${className ?? ''}`,
  };

  const today = moment().startOf('day');

  // isValidDate logic based on `disableDates` prop
  let isValidDate = (current: Moment) => true;

  switch (disableDates) {
    case 'future':
      isValidDate = (current: Moment) => current.isSameOrBefore(today, 'day');
      break;
    case 'todayOnly':
      isValidDate = (current: Moment) => current.isSame(today, 'day');
      break;
    case 'past':
      isValidDate = (current: Moment) => current.isSameOrAfter(today, 'day');
      break;
  }

  const renderInput = (props: any) => (
    <Input
      startIcon={<CalendarIcon />}
      name={name}
      error={error}
      disabled={inputDisabled}
      onKeyDown={(e) => {
        if (props.readOnly) {
          e.preventDefault();
        }
      }}
      endIcon={<ArrowDownIcon />}
      label={label}
      {...props}
    />
  );

  return (
    <DateTime
      dateFormat="DD/MM/YYYY"
      isValidDate={isValidDate}
      inputProps={inputProps}
      onNavigate={() => 'years'}
      initialViewMode={initialView}
      closeOnSelect={true}
      timeFormat={false}
      inputDisabled={inputDisabled}
      value={value ? moment(value) : ''}
      initialValue={initialValue ? moment(initialValue) : ''}
      onChange={(date: any) => handleDateChange(date)}
      open={inputDisabled ? false : undefined}
      renderInput={renderInput}
    />
  );
};

export default Datepicker;
